import { useEffect, useState } from 'react';
import { resolveStorageUrl } from '../utils/storageUrl';

/**
 * Resolves a deal image reference (Firebase Storage path, gs:// reference, or
 * plain URL) into a usable image URL, with localStorage caching. Returns an
 * empty string until resolved or when no path is provided.
 *
 * Synchronously seeds from the localStorage cache so prefetched images render
 * on first paint with no flash.
 */
export function useFirebaseImageUrl(path?: string): string {
  const [url, setUrl] = useState<string>(() =>
    path ? localStorage.getItem(`firebase_logo_${path}`) || '' : ''
  );

  useEffect(() => {
    let cancelled = false;

    if (!path) {
      setUrl('');
      return;
    }

    const cached = localStorage.getItem(`firebase_logo_${path}`);
    if (cached) {
      setUrl(cached);
      return;
    }

    resolveStorageUrl(path).then((resolved) => {
      if (!cancelled) setUrl(resolved);
    });

    return () => {
      cancelled = true;
    };
  }, [path]);

  return url;
}
